import React, { ReactNode, useContext, useEffect, useState } from 'react';

import InternalBackupDashboardContext from '@totem/components/services/backup/internalDashboard/InternalBackupDashboardContext';
import { InternalBackupDashboardRecord } from '@totem/components/services/backup/internalDashboard/types';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { BACKUP_DASHBOARD_ENDPOINT } from '@totem/utilities/endpoints';

type Props = {
  children?: ReactNode;
};

const InternalBackupDashboardContainer = ({ children }: Props) => {
  const { getApiToken } = useContext(UserProfileContext);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<InternalBackupDashboardRecord[]>([]);

  useEffect(() => {
    setLoading(true);

    fetch(BACKUP_DASHBOARD_ENDPOINT, {
      method: 'GET',
      headers: new Headers({
        Authorization: `Bearer ${getApiToken()}`,
      }),
    })
      .then((res) => res.json())
      .then((result: InternalBackupDashboardRecord[]) => {
        setData(result ?? []);

        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [getApiToken]);

  return (
    <InternalBackupDashboardContext.Provider value={{ loading, data }}>
      {children}
    </InternalBackupDashboardContext.Provider>
  );
};

export default InternalBackupDashboardContainer;
